import {useState} from "react";
import {FormattedMessage} from "react-intl";

import HelmetSEO from "../../components/helmetSeo/helmetSeo";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import ListingHeader from "../../components/listingHeader/listingHeader";
import OneColumnArticleListingLayout from "../../components/articleListingLayouts/oneColumnArticleListingLayout/oneColumnArticleListingLayout";
import Pagination from "../../components/pagination/Pagination";
import AuthorDetailPanel from "../../bloks/panels/authorDetailPanel/authorDetailPanel";
import AnimeSeriesCarousel from "../../components/animeShowsCarousel/animeSeriesCarousel";
import HeaderBannerPanel from "../../bloks/panels/headerBannerPanel/headerBannerPanel";

import {useAuthorsArticles} from "../../hooks/useStoryblokArticles";
import {storyblokStoryUuidToUrl} from "../../helpers/URLHelpers";

import styles from "./author.module.scss";
import GetComponentsFromBloks from "../../helpers/bloksRenderer";
import {useOutletContext} from "react-router-dom";
import PageContentWrapper from "../../components/PageContentWrapper";

const PER_PAGE = 10;

function AuthorLayout() {
  const {story} = useOutletContext();
  const [currentPage, setCurrentPage] = useState(1);
  const content = story && story.content;
  const authorName = content.name;
  const pagePath = storyblokStoryUuidToUrl(story ? story.uuid : null);
  const [currentArticles, totalArticles, isLoading] = useAuthorsArticles(
    authorName,
    PER_PAGE,
    currentPage
  );
  const animeSeries = story.content.anime_shows;

  function handlePageChange(newPage) {
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
      const url = new URL(window.location);
      if (newPage === 1) {
        url.searchParams.delete("page");
      } else {
        url.searchParams.set("page", newPage);
      }
      window.history.pushState({}, "", url);
      window.scrollTo(0, 0);
    }
  }

  let asideContents = [];
  if (content.aside && content.aside[0]) {
    asideContents = GetComponentsFromBloks(content.aside, story);
  }

  return (
    <>
      <HelmetSEO
        initialAlternates={[]}
        lang={story && story.lang ? story.lang : "en"}
        page_path={pagePath}
        story_alternates={story ? story.alternates : []}
        seo_data={content.seo || {}}
        fallback_title={content.name && content.name ? content.name : ""}
        fallback_description={content.biography ? content.biography : ""}
        fallback_image_url={
          content.headshot && content.headshot.filename
            ? content.headshot.filename
            : ""
        }
      />
      <Navbar story_language={story.lang} />
      <PageContentWrapper>
        <HeaderBannerPanel
          blok={{margin_top: "default", margin_bottom: "default"}}
          header_banner_panel={story.content.ads.header_banner_panel}
        />
        <AuthorDetailPanel
          image={content.headshot}
          name={content.name}
          byline={content.title}
          bio={content.biography}
          socialMedia={content.socialmedia}
          withClass={styles.authorDetailPanel}
        />

        {animeSeries && animeSeries.length > 0 ? (
          <AnimeSeriesCarousel
            animeSeries={animeSeries}
            authorName={content.possessive_form_of_name || content.name}
          />
        ) : null}
        <div className={styles.mainLayout}>
          <div className={styles.articleListingContainer}>
            <ListingHeader withClass={styles.listingHeader}>
              <h2>
                <FormattedMessage
                  id="component.authorpage.all_articles_by"
                  values={{name: content.name}}
                />
              </h2>
            </ListingHeader>
            {isLoading ? (
              <div className="loader centered" />
            ) : totalArticles > 0 ? (
              <>
                <OneColumnArticleListingLayout
                  withClass={styles.articleListingLayout}
                  articles={currentArticles ? currentArticles : []}
                />
                {totalArticles > PER_PAGE ? (
                  <Pagination
                    currentPage={currentPage}
                    totalCount={totalArticles}
                    onPageChange={handlePageChange}
                    pageSize={PER_PAGE}
                  />
                ) : null}
              </>
            ) : (
              <FormattedMessage id="component.authorpage.no_articles_found" />
            )}
          </div>

          <div className={styles.aside}>{asideContents}</div>
        </div>
      </PageContentWrapper>
      <Footer />
    </>
  );
}

export default AuthorLayout;
